module.exports = __webpack_public_path__ + "static/p5-307f62c821b8a5878fcc2d43f388b19b.png";